import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as dayjs from "dayjs";
import { NgxImageCompressService } from "ngx-image-compress";
import { TrabajadorDTO } from "src/app/models/dto/trabajador.dto";
import { FormModeAlias } from "src/app/models/alias";
import { ADD_PHOTO_URL_DEFAULT, CURP_REGEX, GUID_ZERO } from "src/app/utils/constants";
import dataURItoBlob from "src/app/utils/dataURItoBlob";
import { BlackListService } from "../../blacklist/blacklist.service";
import { OperadoresService } from "../operadores.service";
import { TrabajadorForm } from "src/app/models/forms/trabajador.form";

@Component({
  selector: "app-form-operador",
  templateUrl: "./form.component.html",
})
export class OperadorForm implements OnInit {
  public imgDef = ADD_PHOTO_URL_DEFAULT;
  public curpRegex = CURP_REGEX;
  public form: FormGroup;
  public mode: FormModeAlias = "stanby";
  public defaults?: TrabajadorDTO = undefined;
  public curpValidating = false;
  public curpGood = false;
  public curpBad = false;
  public curpNeedValidate = true;
  public waiting = false;
  public valueImg = "";
  public imgFile: File = undefined;

  @Output() onsave = new EventEmitter<{
    mode: string;
    value: TrabajadorForm;
    file: File;
  }>();
  error_curp: string;

  constructor(
    private fb: FormBuilder,
    public service: OperadoresService,
    public serviceBlack: BlackListService,
    private imageCompress: NgxImageCompressService
  ) {}

  public ngOnInit() {
    this.valueImg = this.imgDef;
    this.buildForm();
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
    this.waiting = false;
    this.valueImg = this.imgDef;
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
    this.waiting = false;
  }

  public setUpdate(row: TrabajadorDTO) {
    this.mode = "update";
    this.defaults = row;
    this.form.controls["IdTrabajador"].setValue(this.defaults?.IdTrabajador);
    this.form.controls["Telefono"].patchValue(this.defaults?.Telefono);
    this.form.controls["Correo"].patchValue(this.defaults?.Correo);
    this.form.controls["Direccion"].patchValue(this.defaults?.Direccion);
    this.form.controls["FechaIngreso"].patchValue(
      this.defaults.FechaIngreso
        ? dayjs(this.defaults.FechaIngreso).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["FechaSalida"].patchValue(
      this.defaults.FechaSalida
        ? dayjs(this.defaults.FechaSalida).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["ApellidoPaterno"].patchValue(
      this.defaults?.ApellidoPaterno
    );
    this.form.controls["ApellidoMaterno"].patchValue(
      this.defaults?.ApellidoMaterno
    );
    this.form.controls["NombreSS"].patchValue(this.defaults?.NombreSS);
    this.form.controls["Sexo"].patchValue(this.defaults?.Sexo);
    this.form.controls["LugarNacimiento"].patchValue(
      this.defaults?.LugarNacimiento
    );
    this.form.controls["CURP"].patchValue(this.defaults?.CURP);
    this.form.controls["NSS"].patchValue(this.defaults?.NSS);
    this.form.controls["RFC"].patchValue(this.defaults?.RFC);
    this.form.controls["Infonavit"].patchValue(this.defaults?.Infonavit);
    this.form.controls["Puesto"].patchValue(this.defaults?.Puesto);
    this.form.controls["Salario"].patchValue(this.defaults?.Salario);
    this.form.controls["Tipo"].patchValue(this.defaults?.Tipo);
    this.form.controls["FechaNacimiento"].patchValue(
      this.defaults.FechaNacimiento
        ? dayjs(this.defaults.FechaNacimiento).format("YYYY-MM-DD")
        : null
    );
    this.curpGood = true;
    this.curpNeedValidate = false;
    this.loadImage();
    this.waiting = false;
  }

  public save() {
    this.waiting = true;
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public update() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      file: this.imgFile,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdTrabajador: [""],
      Telefono: [""],
      Correo: [""],
      Direccion: [""],
      FechaIngreso: [""],
      FechaSalida: [""],

      ApellidoPaterno: [""],
      ApellidoMaterno: [""],
      NombreSS: ["", [Validators.required]],
      Sexo: [""],
      FechaNacimiento: [""],
      LugarNacimiento: [""],
      CURP: ["", [Validators.required, Validators.pattern(this.curpRegex)]],
      NSS: [""],
      RFC: [""],
      Infonavit: [""],
      Puesto: [""],
      Salario: [""],
      Tipo: [3, [Validators.required]],
    });
  }
  public loadImage() {
    this.service.image(this.defaults.IdTrabajador).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = this.imgDef)
    );
  }

  public getImgFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 50, 50) // 50% ratio, 50% quality
        .then((compressedImage) => {
          const blob = dataURItoBlob(compressedImage);
          this.valueImg = compressedImage;
          this.imgFile = new File(
            [blob],
            "Imagen" + new Date().getTime().toString(16)
          );
        });
    });
  }
  errorHandler(event) {
    event.target.src = this.imgDef;
  }
  validateCurp() {
    this.curpValidating = true;
    this.curpNeedValidate = false;
    const c = this.form.value.CURP;
    this.serviceBlack.validate(c, this.defaults?.IdTrabajador ?? GUID_ZERO).subscribe(
      (d: any) => {
        if (d.fail) {
          if (d.msg == "blacklist") {
            this.error_curp =
              "La curp existe en el registro de no recomendados";
          } else if (d.msg == "regex") {
            this.error_curp = "La curp tiene formato invalido";
          } else if (d.msg == "dup") {
            const location =
              d.location == "actives"
                ? "Activos"
                : d.location == "inactives"
                ? "Bajas"
                : "No Reingreso";
            this.error_curp = `La curp pertenece a ${d.nombre}, en el listado ${location}`;
          } else {
            this.error_curp = "Error. Contacte a soporte.";
          }

          this.curpGood = false;
          this.curpBad = true;
        } else {
          this.curpGood = true;
          this.curpBad = false;
        }
        this.curpValidating = false;
      },
      (e) => {
        this.curpNeedValidate = true;
        this.curpValidating = false;
      }
    );
  }
  resetCurpValidation() {
    this.curpNeedValidate = true;
    this.curpValidating = false;
    this.curpGood = false;
    this.curpBad = false;
  }

  async compressImage(image): Promise<string> {
    const compressedImage = await this.imageCompress.compressFile(
      image,
      1,
      50,
      80
    );
    return compressedImage;
  }
}
